// Libs
import { connect } from 'react-redux'

// Component
import HeftyExistingGrid from '../components/HeftyExistingGrid'

// Selectors
import { operations$ } from 'hfty-soil-jobs-dom'
import { selectedField$, hoverSamplingPoint$, selectedSoilTestFilter$ } from 'hfty-map'
import { selectedSamplingPoints$, previousPoints$ } from 'hfty-soil-jobs'
import isPreviousPointsShown$ from 'hfty-map/src/selectors/isPreviousPointsShown'


const mapStateToProps = (state: Object, props: Object) => {
  return {
    gridData: props.gridData,
    operations: operations$(state),
    field: selectedField$(state),
    samplingPoints: selectedSamplingPoints$(state),
    previousPoints: previousPoints$(state),
    isPreviousPointsShown: isPreviousPointsShown$(state),
    selectedSamplingPoint: hoverSamplingPoint$(state),
    filter: selectedSoilTestFilter$(state),
  }
}

export default connect(mapStateToProps)(HeftyExistingGrid)
